import { useQuery } from '@hooks/reactQuery';

import { getComplaintAlarms } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmOran } from '@interfaces/alarms/alarm';
import { IAlarmByVendor } from '@interfaces/alarms/dto/alarmsDTO';

import { EUserRoles } from '@enums/common';

import { ALARM_LIST_RAN_COMPLAINT } from '@constants/queryKeys';

interface IUseQueryAlarmsListRanComplaintReturn {
	isLoading: boolean;
	data: IAlarmOran[];
	countOfRecords: number;
}

export const useQueryAlarmsListRanComplaint = (
	params: IAlarmByVendor,
): IUseQueryAlarmsListRanComplaintReturn => {
	const {
		data,
		isInitialLoading,
	} = useQuery({
		queryKey: [ALARM_LIST_RAN_COMPLAINT, params],
		queryFn: extractQueryParams(getComplaintAlarms),
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		refetchOnWindowFocus: false,
	});

	return {
		isLoading: isInitialLoading,
		data: data?.items || [],
		countOfRecords: data?.count || 0,
	};
};
